import { FieldTypes } from '../../../modules/tables/types';
import { CellConfig } from './types';

export const CELL_CONFIG: Record<FieldTypes, CellConfig> = {
  'short-text': {
    icon: { asset: 'Text' },
    size: 'Small',
    type: 'ShortText',
  },
  'long-text': {
    icon: { asset: 'LongText' },
    size: 'Large',
    type: 'LongText',
  },
  'number': {
    icon: { asset: 'Number' },
    size: 'Medium',
    type: 'Number',
  },
  'date': {
    icon: { asset: 'DatePickerOutline' },
    size: 'Medium',
    type: 'Date',
  },
  'time': {
    icon: { asset: 'Clock' },
    size: 'Medium',
    type: 'Date',
  },
  'date-time': {
    icon: { asset: 'DatePickerFilled' },
    size: 'Medium',
    type: 'Date',
  },
  'select': {
    icon: { asset: 'Select' },
    size: 'Medium',
    type: 'SingleSelect',
  },
  'multi-select': {
    icon: { asset: 'Select' },
    size: 'Medium',
    type: 'MultiSelect',
  },
  'image': {
    icon: { asset: 'Image' },
    size: 'Small',
    type: 'Image',
  },
  'boolean': {
    icon: { asset: 'Select' },
    size: 'Medium',
    type: 'SingleSelect',
  },
  'json': {
    icon: { asset: 'Code' },
    size: 'Large',
    type: 'JSON',
  },
  'single-reference': {
    icon: { asset: 'Link' },
    size: 'Medium',
    type: 'SingleSelect',
  },
  'multi-reference': {
    icon: { asset: 'Link' },
    size: 'Medium',
    type: 'MultiReference',
  },
};
